import { Accordion } from 'components';
import { useTranslation } from 'react-i18next';
import { STextField } from './styled';
import { Box as MuiBox, useTheme } from '@mui/material';
import { FormControl, DatePicker } from 'components/ui';
import MedicalServicesOutlinedIcon from '@mui/icons-material/MedicalServicesOutlined';
import { useEffect } from 'react';

export default function Coverage({ form }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const values = form.getState().values;

  useEffect(() => {
    if (
      values?.coverage?.validityStartDate === null ||
      values?.coverage?.validityStartDate === undefined
    ) {
      form.change('coverage.validityEndDate', null);
    }
  }, [
    values?.coverage?.validityStartDate,
    values?.coverage?.validityEndDate,
    form,
  ]);

  return (
    <Accordion
      title={t('Coverage')}
      startAdornment={<MedicalServicesOutlinedIcon />}
    >
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('Health insurance ID')}>
          <STextField
            name="coverage.healthInsuranceId"
            placeholder={t('Health insurance ID')}
          />
        </FormControl>
        <FormControl label={t('Health insurance beneficiary')}>
          <STextField
            name="coverage.healthInsuranceBeneficiary"
            placeholder={t('Health insurance beneficiary')}
          />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('Health insurance issuer name')}>
          <STextField
            name="coverage.healthInsuranceIssuerName"
            placeholder={t('Health insurance issuer name')}
          />
        </FormControl>
        <FormControl label={t('Health insurance coverage type')}>
          <STextField
            name="coverage.healthInsuranceCoverageType"
            placeholder={t('Health insurance coverage type')}
          />
        </FormControl>
      </MuiBox>
      <MuiBox style={{ display: 'flex', gap: 30 }}>
        <FormControl label={t('Validity start date')}>
          <DatePicker
            name="coverage.validityStartDate"
            inputProps={{
              style: {
                backgroundColor: theme.palette.colors.white,
              },
            }}
            dataId="date-picker-dialog"
            id="date-picker-dialog"
            openTo="year"
            disableFuture={true}
            placeholder={t('Validity start date')}
          />
        </FormControl>

        {values?.coverage?.validityStartDate && (
          <FormControl label={t('Validity end date')}>
            <DatePicker
              name="coverage.validityEndDate"
              inputProps={{
                style: {
                  backgroundColor: theme.palette.colors.white,
                },
              }}
              dataId="date-picker-dialog"
              id="date-picker-dialog"
              openTo="year"
              placeholder={t('Validity end date')}
              minDate={values?.coverage?.validityStartDate}
            />
          </FormControl>
        )}
      </MuiBox>
    </Accordion>
  );
}
